// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
    --primary-color: #0A2239;
    --secondary-color: #FFA400;
    --text-color: #0A2239;
    --background-color: #f4f4f4;
    --spacing: 16px;
    --border-radius: 8px;
    --header-height: 80px;
    --container-padding: 16px;
    --button-height: 48px;
    --input-height: 48px;
}

@media (min-width: 768px) {
    :root {
        --spacing: 24px;
        --container-padding: 32px;
    }
}

/* Reset and base styles */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

html {
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
}

body {
    font-family: 'Segoe UI', Arial, sans-serif;
    background-color: var(--background-color);
    color: var(--text-color);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    width: 100%;
    min-height: 100vh;
    padding-bottom: env(safe-area-inset-bottom);
}

/* Header and Logo */
header {
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    height: var(--header-height);
    padding: var(--container-padding);
}

.header-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
}

.header-controls {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.language-selector {
    position: relative;
    margin-right: 1rem;
}

.current-language {
    background: rgba(10, 34, 57, 0.1);
    border: none;
    border-radius: var(--border-radius);
    color: var(--primary-color);
    padding: 0.5rem 0.75rem;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.current-language:hover {
    background: rgba(10, 34, 57, 0.2);
}

.current-language .flag {
    font-size: 1.2rem;
}

.current-language .lang-name {
    font-size: 0.9rem;
    font-weight: 500;
}

.current-language .arrow {
    font-size: 0.8rem;
    transition: transform 0.2s ease;
}

.current-language[aria-expanded="true"] .arrow {
    transform: rotate(180deg);
}

.language-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 4px;
    background: white;
    border-radius: var(--border-radius);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    z-index: 1000;
    opacity: 1;
    transform: translateY(0);
    transition: all 0.2s ease;
}

.language-dropdown.hidden {
    opacity: 0;
    transform: translateY(-8px);
    pointer-events: none;
}

.language-dropdown .language-option {
    width: 100%;
    padding: 0.75rem 1rem;
    border: none;
    background: none;
    color: var(--text-color);
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    text-align: left;
}

.language-dropdown .language-option:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.language-dropdown .flag {
    font-size: 1.2rem;
}

.language-dropdown .lang-name {
    font-size: 0.9rem;
}

[lang="ar"] .language-dropdown .language-option {
    text-align: right;
}

@media (max-width: 768px) {
    .current-language .lang-name {
        display: none;
    }
    
    .current-language {
        padding: 0.4rem;
    }
    
    .language-selector {
        margin-right: 0.5rem;
    }
}

.logo {
    width: 220px;
    height: auto;
}

/* Input Section Styles */
.input-section {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
    margin-bottom: var(--spacing);
    max-width: 600px;
    margin: 0 auto var(--spacing);
    width: 100%;
    padding: var(--spacing);
}

.video-type-select {
    position: relative;
}

.video-type-select select {
    width: 100%;
    height: var(--input-height);
    padding: 0 var(--spacing);
    border: 2px solid var(--primary-color);
    border-radius: var(--border-radius);
    background-color: white;
    color: var(--text-color);
    font-size: 1rem;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
}

.video-type-select select:invalid,
#location:invalid {
    border-color: #ff6b6b;
}

#title {
    background-color: #f8f9fa;
    cursor: not-allowed;
    color: var(--text-color);
    opacity: 1;
    -webkit-text-fill-color: var(--text-color);
}

#title:disabled {
    color: var(--text-color);
    opacity: 1;
    -webkit-text-fill-color: var(--text-color);
}

.video-type-select::after {
    content: '▾';
    position: absolute;
    right: var(--spacing);
    top: 50%;
    transform: translateY(-50%);
    color: var(--primary-color);
    pointer-events: none;
}

[lang="ar"] .video-type-select::after {
    right: auto;
    left: var(--spacing);
}

.video-type-select select:focus {
    outline: none;
    border-color: var(--secondary-color);
    box-shadow: 0 0 0 2px rgba(255, 164, 0, 0.2);
}

.video-type-select select option {
    padding: 0.5rem;
}

/* Modale de vidéo */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal.hidden {
    display: none;
}

.modal-content {
    background-color: white;
    border-radius: var(--border-radius);
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: var(--spacing);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--background-color);
}

.modal-header h2 {
    margin: 0;
    font-size: 1.5rem;
    color: var(--text-color);
}

.modal-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
    color: var(--text-color);
}

.modal-body {
    padding: var(--spacing);
    overflow-y: auto;
}

#video-preview {
    width: 100%;
    border-radius: var(--border-radius);
    margin-bottom: var(--spacing);
}

.modal-buttons {
    display: flex;
    gap: var(--spacing);
    justify-content: flex-end;
}

.button {
    padding: 0.75rem 1.5rem;
    border-radius: var(--border-radius);
    border: none;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
}

.button.primary {
    background-color: var(--primary-color);
    color: white;
}

.button.secondary {
    background-color: var(--background-color);
    color: var(--text-color);
}

.button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .modal-buttons {
        flex-direction: column;
    }

    .button {
        width: 100%;
    }
}

/* Menu Hamburger */
.menu-toggle {
    width: 40px;
    height: 40px;
    padding: 8px;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.menu-toggle span {
    display: block;
    width: 24px;
    height: 2px;
    background-color: var(--primary-color);
    transition: all 0.3s ease;
}

/* Menu Overlay */
.menu-overlay {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.menu-overlay.hidden {
    opacity: 0;
    pointer-events: none;
}

.menu-content {
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
    height: 100%;
    background-color: white;
    padding: 20px;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    transform: translateX(0);
    transition: transform 0.3s ease;
}

.menu-overlay.hidden .menu-content {
    transform: translateX(100%);
}

.menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.menu-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 8px;
    color: var(--text-color);
}

.menu-section {
    margin-bottom: 30px;
}

.menu-section h3 {
    color: var(--primary-color);
    margin-bottom: 15px;
    font-size: 1.1rem;
}

.language-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.language-list li {
    width: 100%;
}

.language-option {
    width: 100%;
    padding: 12px;
    border: none;
    border-radius: var(--border-radius);
    background: none;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 1rem;
}

.language-option:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.language-option.active {
    background-color: var(--primary-color);
    color: white;
}

.language-option .flag {
    font-size: 1.5rem;
    flex-shrink: 0;
}

.language-option .lang-name {
    flex-grow: 1;
    text-align: left;
}

.language-option .check {
    opacity: 0;
    color: var(--secondary-color);
    font-weight: bold;
    transition: opacity 0.2s ease;
}

.language-option.active .check {
    opacity: 1;
}

/* RTL Support pour la liste des langues */
[lang="ar"] .language-option .lang-name {
    text-align: right;
}

.menu-links {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.menu-links a {
    color: var(--text-color);
    text-decoration: none;
    padding: 8px 0;
    transition: color 0.2s ease;
}

.menu-links a:hover {
    color: var(--secondary-color);
}

/* RTL Support pour le menu */
[lang="ar"] .menu-content {
    left: 0;
    right: auto;
    transform: translateX(-100%);
}

[lang="ar"] .menu-overlay.hidden .menu-content {
    transform: translateX(-100%);
}

[lang="ar"] .language-option {
    text-align: right;
}

/* Style pour le texte en arabe */
[lang="ar"] {
    direction: rtl;
    text-align: right;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

@media (min-width: 481px) {
    .logo {
        width: 280px;
    }
}

/* Layout */
main {
    width: 100%;
    padding: var(--container-padding);
    margin: 0 auto;
}

section {
    margin-bottom: var(--spacing);
    width: 100%;
}

@media (min-width: 768px) {
    main {
        max-width: 768px;
    }
    
    section {
        margin-bottom: calc(var(--spacing) * 2);
    }
}

@media (min-width: 1024px) {
    main {
        max-width: 1024px;
    }
}

@media (min-width: 1200px) {
    main {
        max-width: 1200px;
    }
}

/* Forms and Inputs */
.input-section {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) / 2);
    width: 100%;
}

input {
    width: 100%;
    height: var(--input-height);
    padding: 0 16px;
    border: 2px solid #ddd;
    border-radius: var(--border-radius);
    font-size: 1rem;
    transition: all 0.3s ease;
    -webkit-appearance: none;
    appearance: none;
}

input:focus {
    border-color: var(--primary-color);
    outline: none;
    box-shadow: 0 0 0 3px rgba(10, 34, 57, 0.1);
}

@media (min-width: 768px) {
    .input-section {
        gap: var(--spacing);
    }
}

.location-input-group {
    position: relative;
    display: flex;
    align-items: center;
}

.location-input-group input {
    flex: 1;
    padding-right: 40px;
}

.icon-button {
    background: none;
    border: none;
    padding: 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
}

.icon-button:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.icon-button .icon {
    font-size: 20px;
}

.location-loading {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
}

/* Buttons and Actions */
.action-buttons {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) / 2);
    width: 100%;
}

@media (min-width: 768px) {
    .action-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: var(--spacing);
    }
}

/* Buttons */
.primary-button,
.secondary-button {
    width: 100%;
    height: var(--button-height);
    border: none;
    border-radius: var(--border-radius);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 1rem;
    font-weight: 600;
    padding: 0 24px;
    transition: all 0.2s ease;
    -webkit-tap-highlight-color: transparent;
}

.primary-button {
    background-color: var(--primary-color);
    color: white;
}

.primary-button:hover {
    background-color: #0d2b4a;
    transform: translateY(-2px);
}

.secondary-button {
    background-color: #757575;
    color: white;
}

.secondary-button:hover {
    background-color: #616161;
    transform: translateY(-2px);
}

.primary-button:active,
.secondary-button:active {
    transform: translateY(1px);
}

@media (min-width: 768px) {
    .primary-button,
    .secondary-button {
        width: auto;
        min-width: 200px;
    }
}

.icon {
    font-size: 20px;
}

/* Gallery Container */
.photo-gallery {
    background-color: white;
    padding: calc(var(--spacing) / 2);
    border-radius: var(--border-radius);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow: hidden;
}

@media (min-width: 768px) {
    .photo-gallery {
        padding: var(--spacing);
        border-radius: calc(var(--border-radius) * 1.5);
    }
}

/* Photo Gallery */
.photos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: calc(var(--spacing) / 2);
    margin-top: var(--spacing);
}

/* Camera Modal Styles */
.camera-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #000;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
}

.camera-modal.hidden {
    display: none;
}

.video-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-container video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: transparent;
}

.camera-controls {
    position: absolute;
    bottom: max(1rem, env(safe-area-inset-bottom));
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0 1rem;
    z-index: 10;
}

.camera-controls-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.camera-select {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(4px);
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: var(--border-radius);
    padding: 8px 12px;
    font-size: 14px;
    color: white;
    max-width: 200px;
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
}

.camera-select:focus {
    outline: none;
    border-color: var(--secondary-color);
}

.camera-select option {
    background: #333;
    color: white;
}

.camera-controls .icon-button {
    position: relative;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(4px);
    border: 2px solid rgba(255, 255, 255, 0.5);
    width: 48px;
    height: 48px;
    right: unset;
}

.camera-controls .primary-button {
    background: var(--primary-color);
    border: none;
    width: 64px;
    height: 64px;
    min-width: unset;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

/* Styles pour le mode plein écran */
.video-container.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding-top: 0;
    z-index: 1000;
    background: #000;
}

.video-container.fullscreen video {
    object-fit: contain;
    width: 100%;
}

@media (min-width: 768px) {
    .photos-grid {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: var(--spacing);
    }
}

.photo-item {
    position: relative;
    border-radius: var(--border-radius);
    overflow: hidden;
    background: var(--background-color);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    aspect-ratio: 4/3;
}

.photo-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.photo-controls {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 0.5rem;
    background: linear-gradient(rgba(0, 0, 0, 0.5), transparent);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.photo-controls .icon-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    padding: 0.5rem;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.3s;
    z-index: 2;
}

.photo-controls .delete-photo .icon {
    font-size: 24px;
    font-weight: bold;
    position: absolute;
    top: 8px;
    right: 8px;
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.photo-controls .icon-button:hover {
    background: rgba(255, 255, 255, 0.3);
}

.recording-time {
    font-size: 0.8rem;
    color: white;
    margin-left: 0.5rem;
}

.record-audio.recording {
    animation: pulse 1.5s infinite;
    background: rgba(255, 0, 0, 0.5);
}

.audio-wave {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--primary-color);
    transform-origin: left;
    transform: scaleX(0);
    transition: transform 0.3s;
}

.photo-item.has-audio .audio-wave {
    transform: scaleX(1);
}

@keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
}

.delete-photo {
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: rgba(255,0,0,0.8);
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.generate-button {
    background-color: var(--secondary-color);
    font-size: 18px;
    padding: 16px 32px;
}

.generate-button:hover {
    background-color: #FFA000;
}

/* Video Preview */
.video-preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: white;
    padding: var(--container-padding);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) / 2);
}

@media (min-width: 768px) {
    .video-preview {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: auto;
        height: auto;
        max-width: 90vw;
        max-height: 90vh;
        border-radius: var(--border-radius);
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
        padding: var(--spacing);
        gap: var(--spacing);
    }
}

.close-preview {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0,0,0,0.5);
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
}

.recording-interface {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
    min-width: 300px;
    max-width: 90vw;
}

.progress-interface {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
    min-width: 300px;
    max-width: 90vw;
    text-align: center;
}

.preview-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.close-button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
    color: #666;
    transition: color 0.2s;
}

.close-button:hover {
    color: #000;
}

.preview-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
}

.progress-status {
    font-size: 16px;
    margin-bottom: 10px;
}

.progress-bar {
    width: 100%;
    height: 8px;
    background-color: #eee;
    border-radius: 4px;
    overflow: hidden;
}

.progress-fill {
    width: 0;
    height: 100%;
    background-color: var(--primary-color);
    transition: width 0.3s ease;
}

/* Responsive Design */
@media (max-width: 768px) {
    .action-buttons {
        flex-direction: column;
    }

    .primary-button {
        width: 100%;
    }

    .photos-grid {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }

    .video-preview {
        width: 100vw;
        height: 100vh;
        max-width: 100vw;
        border-radius: 0;
        padding: 40px 20px;
    }

    .recording-interface {
        width: 100%;
        bottom: 0;
        border-radius: 12px 12px 0 0;
    }
}

`, "",{"version":3,"sources":["webpack://./style.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI;QACI,eAAe;QACf,yBAAyB;IAC7B;AACJ;;AAEA,0BAA0B;AAC1B;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,wBAAwB;IACxB,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,uBAAuB;IACvB,qCAAqC;IACrC,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,mCAAmC;IACnC,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,mCAAmC;IACnC,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,sCAAsC;IACtC,mCAAmC;IACnC,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,4CAA4C;AAChD;;AAEA;IACI,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,yCAAyC;IACzC,gBAAgB;IAChB,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA,0CAA0C;AAC1C;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,6BAA6B;AAC7B;IACI,OAAO;IACP,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iCAAiC;AACjC;IACI,cAAc;IACd,iBAAiB;IACjB,mJAAmJ;AACvJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,WAAW;AACX;IACI,WAAW;IACX,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,uCAAuC;IAC3C;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;IACtB,mCAAmC;IACnC,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,MAAM,YAAY,EAAE;IACpB,OAAO,UAAU,EAAE;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA,YAAY;AACZ;;IAEI,WAAW;IACX,4BAA4B;IAC5B,YAAY;IACZ,mCAAmC;IACnC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI;;QAEI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,uBAAuB;IACvB,iCAAiC;IACjC,mCAAmC;IACnC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;QACvB,+CAA+C;IACnD;AACJ;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,4DAA4D;IAC5D,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,0CAA0C;IAC1C,mCAAmC;IACnC,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,0BAA0B;IAC1B,0CAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,4DAA4D;QAC5D,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,mCAAmC;IACnC,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,eAAe;IACf,4DAA4D;IAC5D,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,KAAK,mBAAmB,EAAE;IAC1B,MAAM,qBAAqB,EAAE;IAC7B,OAAO,mBAAmB,EAAE;AAChC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,mCAAmC;IACnC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,mCAAmC;QACnC,sCAAsC;QACtC,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4DAA4D;IAChE;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,4BAA4B;IAChC;AACJ","sourcesContent":["/* Variables */\n:root {\n    --primary-color: #0A2239;\n    --secondary-color: #FFA400;\n    --text-color: #0A2239;\n    --background-color: #f4f4f4;\n    --spacing: 16px;\n    --border-radius: 8px;\n    --header-height: 80px;\n    --container-padding: 16px;\n    --button-height: 48px;\n    --input-height: 48px;\n}\n\n@media (min-width: 768px) {\n    :root {\n        --spacing: 24px;\n        --container-padding: 32px;\n    }\n}\n\n/* Reset and base styles */\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\nhtml {\n    font-size: 16px;\n    -webkit-text-size-adjust: 100%;\n}\n\nbody {\n    font-family: 'Segoe UI', Arial, sans-serif;\n    background-color: var(--background-color);\n    color: var(--text-color);\n    line-height: 1.6;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow-x: hidden;\n    width: 100%;\n    min-height: 100vh;\n    padding-bottom: env(safe-area-inset-bottom);\n}\n\n/* Header and Logo */\nheader {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background-color: white;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    height: var(--header-height);\n    padding: var(--container-padding);\n}\n\n.header-content {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.header-controls {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.language-selector {\n    position: relative;\n    margin-right: 1rem;\n}\n\n.current-language {\n    background: rgba(10, 34, 57, 0.1);\n    border: none;\n    border-radius: var(--border-radius);\n    color: var(--primary-color);\n    padding: 0.5rem 0.75rem;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.current-language:hover {\n    background: rgba(10, 34, 57, 0.2);\n}\n\n.current-language .flag {\n    font-size: 1.2rem;\n}\n\n.current-language .lang-name {\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n.current-language .arrow {\n    font-size: 0.8rem;\n    transition: transform 0.2s ease;\n}\n\n.current-language[aria-expanded=\"true\"] .arrow {\n    transform: rotate(180deg);\n}\n\n.language-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 4px;\n    background: white;\n    border-radius: var(--border-radius);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    overflow: hidden;\n    z-index: 1000;\n    opacity: 1;\n    transform: translateY(0);\n    transition: all 0.2s ease;\n}\n\n.language-dropdown.hidden {\n    opacity: 0;\n    transform: translateY(-8px);\n    pointer-events: none;\n}\n\n.language-dropdown .language-option {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border: none;\n    background: none;\n    color: var(--text-color);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    text-align: left;\n}\n\n.language-dropdown .language-option:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.language-dropdown .flag {\n    font-size: 1.2rem;\n}\n\n.language-dropdown .lang-name {\n    font-size: 0.9rem;\n}\n\n[lang=\"ar\"] .language-dropdown .language-option {\n    text-align: right;\n}\n\n@media (max-width: 768px) {\n    .current-language .lang-name {\n        display: none;\n    }\n    \n    .current-language {\n        padding: 0.4rem;\n    }\n    \n    .language-selector {\n        margin-right: 0.5rem;\n    }\n}\n\n.logo {\n    width: 220px;\n    height: auto;\n}\n\n/* Input Section Styles */\n.input-section {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing);\n    margin-bottom: var(--spacing);\n    max-width: 600px;\n    margin: 0 auto var(--spacing);\n    width: 100%;\n    padding: var(--spacing);\n}\n\n.video-type-select {\n    position: relative;\n}\n\n.video-type-select select {\n    width: 100%;\n    height: var(--input-height);\n    padding: 0 var(--spacing);\n    border: 2px solid var(--primary-color);\n    border-radius: var(--border-radius);\n    background-color: white;\n    color: var(--text-color);\n    font-size: 1rem;\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n}\n\n.video-type-select select:invalid,\n#location:invalid {\n    border-color: #ff6b6b;\n}\n\n#title {\n    background-color: #f8f9fa;\n    cursor: not-allowed;\n    color: var(--text-color);\n    opacity: 1;\n    -webkit-text-fill-color: var(--text-color);\n}\n\n#title:disabled {\n    color: var(--text-color);\n    opacity: 1;\n    -webkit-text-fill-color: var(--text-color);\n}\n\n.video-type-select::after {\n    content: '▾';\n    position: absolute;\n    right: var(--spacing);\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--primary-color);\n    pointer-events: none;\n}\n\n[lang=\"ar\"] .video-type-select::after {\n    right: auto;\n    left: var(--spacing);\n}\n\n.video-type-select select:focus {\n    outline: none;\n    border-color: var(--secondary-color);\n    box-shadow: 0 0 0 2px rgba(255, 164, 0, 0.2);\n}\n\n.video-type-select select option {\n    padding: 0.5rem;\n}\n\n/* Modale de vidéo */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal.hidden {\n    display: none;\n}\n\n.modal-content {\n    background-color: white;\n    border-radius: var(--border-radius);\n    width: 90%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.modal-header {\n    padding: var(--spacing);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid var(--background-color);\n}\n\n.modal-header h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: var(--text-color);\n}\n\n.modal-close {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    padding: 0.5rem;\n    color: var(--text-color);\n}\n\n.modal-body {\n    padding: var(--spacing);\n    overflow-y: auto;\n}\n\n#video-preview {\n    width: 100%;\n    border-radius: var(--border-radius);\n    margin-bottom: var(--spacing);\n}\n\n.modal-buttons {\n    display: flex;\n    gap: var(--spacing);\n    justify-content: flex-end;\n}\n\n.button {\n    padding: 0.75rem 1.5rem;\n    border-radius: var(--border-radius);\n    border: none;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.button.primary {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n.button.secondary {\n    background-color: var(--background-color);\n    color: var(--text-color);\n}\n\n.button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .modal-buttons {\n        flex-direction: column;\n    }\n\n    .button {\n        width: 100%;\n    }\n}\n\n/* Menu Hamburger */\n.menu-toggle {\n    width: 40px;\n    height: 40px;\n    padding: 8px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.menu-toggle span {\n    display: block;\n    width: 24px;\n    height: 2px;\n    background-color: var(--primary-color);\n    transition: all 0.3s ease;\n}\n\n/* Menu Overlay */\n.menu-overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    opacity: 1;\n    transition: opacity 0.3s ease;\n}\n\n.menu-overlay.hidden {\n    opacity: 0;\n    pointer-events: none;\n}\n\n.menu-content {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 300px;\n    height: 100%;\n    background-color: white;\n    padding: 20px;\n    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);\n    overflow-y: auto;\n    transform: translateX(0);\n    transition: transform 0.3s ease;\n}\n\n.menu-overlay.hidden .menu-content {\n    transform: translateX(100%);\n}\n\n.menu-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.menu-close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    padding: 8px;\n    color: var(--text-color);\n}\n\n.menu-section {\n    margin-bottom: 30px;\n}\n\n.menu-section h3 {\n    color: var(--primary-color);\n    margin-bottom: 15px;\n    font-size: 1.1rem;\n}\n\n.language-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.language-list li {\n    width: 100%;\n}\n\n.language-option {\n    width: 100%;\n    padding: 12px;\n    border: none;\n    border-radius: var(--border-radius);\n    background: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 1rem;\n}\n\n.language-option:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.language-option.active {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n.language-option .flag {\n    font-size: 1.5rem;\n    flex-shrink: 0;\n}\n\n.language-option .lang-name {\n    flex-grow: 1;\n    text-align: left;\n}\n\n.language-option .check {\n    opacity: 0;\n    color: var(--secondary-color);\n    font-weight: bold;\n    transition: opacity 0.2s ease;\n}\n\n.language-option.active .check {\n    opacity: 1;\n}\n\n/* RTL Support pour la liste des langues */\n[lang=\"ar\"] .language-option .lang-name {\n    text-align: right;\n}\n\n.menu-links {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.menu-links a {\n    color: var(--text-color);\n    text-decoration: none;\n    padding: 8px 0;\n    transition: color 0.2s ease;\n}\n\n.menu-links a:hover {\n    color: var(--secondary-color);\n}\n\n/* RTL Support pour le menu */\n[lang=\"ar\"] .menu-content {\n    left: 0;\n    right: auto;\n    transform: translateX(-100%);\n}\n\n[lang=\"ar\"] .menu-overlay.hidden .menu-content {\n    transform: translateX(-100%);\n}\n\n[lang=\"ar\"] .language-option {\n    text-align: right;\n}\n\n/* Style pour le texte en arabe */\n[lang=\"ar\"] {\n    direction: rtl;\n    text-align: right;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.logo img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n@media (min-width: 481px) {\n    .logo {\n        width: 280px;\n    }\n}\n\n/* Layout */\nmain {\n    width: 100%;\n    padding: var(--container-padding);\n    margin: 0 auto;\n}\n\nsection {\n    margin-bottom: var(--spacing);\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    main {\n        max-width: 768px;\n    }\n    \n    section {\n        margin-bottom: calc(var(--spacing) * 2);\n    }\n}\n\n@media (min-width: 1024px) {\n    main {\n        max-width: 1024px;\n    }\n}\n\n@media (min-width: 1200px) {\n    main {\n        max-width: 1200px;\n    }\n}\n\n/* Forms and Inputs */\n.input-section {\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--spacing) / 2);\n    width: 100%;\n}\n\ninput {\n    width: 100%;\n    height: var(--input-height);\n    padding: 0 16px;\n    border: 2px solid #ddd;\n    border-radius: var(--border-radius);\n    font-size: 1rem;\n    transition: all 0.3s ease;\n    -webkit-appearance: none;\n    appearance: none;\n}\n\ninput:focus {\n    border-color: var(--primary-color);\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(10, 34, 57, 0.1);\n}\n\n@media (min-width: 768px) {\n    .input-section {\n        gap: var(--spacing);\n    }\n}\n\n.location-input-group {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.location-input-group input {\n    flex: 1;\n    padding-right: 40px;\n}\n\n.icon-button {\n    background: none;\n    border: none;\n    padding: 0.5rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: background-color 0.2s;\n}\n\n.icon-button:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.icon-button .icon {\n    font-size: 20px;\n}\n\n.location-loading {\n    animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n    0% { opacity: 1; }\n    50% { opacity: 0.5; }\n    100% { opacity: 1; }\n}\n\n/* Buttons and Actions */\n.action-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--spacing) / 2);\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .action-buttons {\n        flex-direction: row;\n        flex-wrap: wrap;\n        gap: var(--spacing);\n    }\n}\n\n/* Buttons */\n.primary-button,\n.secondary-button {\n    width: 100%;\n    height: var(--button-height);\n    border: none;\n    border-radius: var(--border-radius);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0 24px;\n    transition: all 0.2s ease;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.primary-button {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n.primary-button:hover {\n    background-color: #0d2b4a;\n    transform: translateY(-2px);\n}\n\n.secondary-button {\n    background-color: #757575;\n    color: white;\n}\n\n.secondary-button:hover {\n    background-color: #616161;\n    transform: translateY(-2px);\n}\n\n.primary-button:active,\n.secondary-button:active {\n    transform: translateY(1px);\n}\n\n@media (min-width: 768px) {\n    .primary-button,\n    .secondary-button {\n        width: auto;\n        min-width: 200px;\n    }\n}\n\n.icon {\n    font-size: 20px;\n}\n\n/* Gallery Container */\n.photo-gallery {\n    background-color: white;\n    padding: calc(var(--spacing) / 2);\n    border-radius: var(--border-radius);\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    overflow: hidden;\n}\n\n@media (min-width: 768px) {\n    .photo-gallery {\n        padding: var(--spacing);\n        border-radius: calc(var(--border-radius) * 1.5);\n    }\n}\n\n/* Photo Gallery */\n.photos-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: calc(var(--spacing) / 2);\n    margin-top: var(--spacing);\n}\n\n/* Camera Modal Styles */\n.camera-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: #000;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: env(safe-area-inset-top);\n    padding-bottom: env(safe-area-inset-bottom);\n}\n\n.camera-modal.hidden {\n    display: none;\n}\n\n.video-container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.video-container video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    background: transparent;\n}\n\n.camera-controls {\n    position: absolute;\n    bottom: max(1rem, env(safe-area-inset-bottom));\n    left: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 0 1rem;\n    z-index: 10;\n}\n\n.camera-controls-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.camera-select {\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(4px);\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-radius: var(--border-radius);\n    padding: 8px 12px;\n    font-size: 14px;\n    color: white;\n    max-width: 200px;\n    cursor: pointer;\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n.camera-select:focus {\n    outline: none;\n    border-color: var(--secondary-color);\n}\n\n.camera-select option {\n    background: #333;\n    color: white;\n}\n\n.camera-controls .icon-button {\n    position: relative;\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(4px);\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    width: 48px;\n    height: 48px;\n    right: unset;\n}\n\n.camera-controls .primary-button {\n    background: var(--primary-color);\n    border: none;\n    width: 64px;\n    height: 64px;\n    min-width: unset;\n    border-radius: 50%;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n/* Styles pour le mode plein écran */\n.video-container.fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    padding-top: 0;\n    z-index: 1000;\n    background: #000;\n}\n\n.video-container.fullscreen video {\n    object-fit: contain;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .photos-grid {\n        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n        gap: var(--spacing);\n    }\n}\n\n.photo-item {\n    position: relative;\n    border-radius: var(--border-radius);\n    overflow: hidden;\n    background: var(--background-color);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    aspect-ratio: 4/3;\n}\n\n.photo-item img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.photo-controls {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding: 0.5rem;\n    background: linear-gradient(rgba(0, 0, 0, 0.5), transparent);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.photo-controls .icon-button {\n    background: rgba(255, 255, 255, 0.2);\n    border: none;\n    color: white;\n    padding: 0.5rem;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    z-index: 2;\n}\n\n.photo-controls .delete-photo .icon {\n    font-size: 24px;\n    font-weight: bold;\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    color: white;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.photo-controls .icon-button:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.recording-time {\n    font-size: 0.8rem;\n    color: white;\n    margin-left: 0.5rem;\n}\n\n.record-audio.recording {\n    animation: pulse 1.5s infinite;\n    background: rgba(255, 0, 0, 0.5);\n}\n\n.audio-wave {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: var(--primary-color);\n    transform-origin: left;\n    transform: scaleX(0);\n    transition: transform 0.3s;\n}\n\n.photo-item.has-audio .audio-wave {\n    transform: scaleX(1);\n}\n\n@keyframes pulse {\n    0% { transform: scale(1); }\n    50% { transform: scale(1.1); }\n    100% { transform: scale(1); }\n}\n\n.delete-photo {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background-color: rgba(255,0,0,0.8);\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.generate-button {\n    background-color: var(--secondary-color);\n    font-size: 18px;\n    padding: 16px 32px;\n}\n\n.generate-button:hover {\n    background-color: #FFA000;\n}\n\n/* Video Preview */\n.video-preview {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background: white;\n    padding: var(--container-padding);\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--spacing) / 2);\n}\n\n@media (min-width: 768px) {\n    .video-preview {\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: auto;\n        height: auto;\n        max-width: 90vw;\n        max-height: 90vh;\n        border-radius: var(--border-radius);\n        box-shadow: 0 4px 20px rgba(0,0,0,0.2);\n        padding: var(--spacing);\n        gap: var(--spacing);\n    }\n}\n\n.close-preview {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: rgba(0,0,0,0.5);\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n}\n\n.recording-interface {\n    position: fixed;\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: white;\n    padding: 20px;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.2);\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing);\n    min-width: 300px;\n    max-width: 90vw;\n}\n\n.progress-interface {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 20px;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.2);\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing);\n    min-width: 300px;\n    max-width: 90vw;\n    text-align: center;\n}\n\n.preview-container {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.preview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.close-button {\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    padding: 5px;\n    color: #666;\n    transition: color 0.2s;\n}\n\n.close-button:hover {\n    color: #000;\n}\n\n.preview-actions {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.progress-status {\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.progress-bar {\n    width: 100%;\n    height: 8px;\n    background-color: #eee;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.progress-fill {\n    width: 0;\n    height: 100%;\n    background-color: var(--primary-color);\n    transition: width 0.3s ease;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .action-buttons {\n        flex-direction: column;\n    }\n\n    .primary-button {\n        width: 100%;\n    }\n\n    .photos-grid {\n        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    }\n\n    .video-preview {\n        width: 100vw;\n        height: 100vh;\n        max-width: 100vw;\n        border-radius: 0;\n        padding: 40px 20px;\n    }\n\n    .recording-interface {\n        width: 100%;\n        bottom: 0;\n        border-radius: 12px 12px 0 0;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
